import { ListBulletsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Specifications = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ListBulletsIcon size={Sizes[size]} mirrored {...rest} color={fill} />;
};

Specifications.displayName = 'Specifications';
